import { Button, Col, Form, Modal, Radio, Row, Space } from "antd";

function VehicleModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
}) {
  return (
    <Modal
      title={"Update User"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={onSave}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
              }
            : {}
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Is Admin"
              name="is_admin"
              rules={[
                {
                  required: true,
                  message: "Please select Is Admin",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Is Supervisor"
              name="is_supervisor"
              rules={[
                {
                  required: true,
                  message: "Please select Is Supervisor",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {"Save"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default VehicleModal;
